export const isShowTermsAndPrivacy = window.location.host.includes('lookofray') || window.location.host.includes('localhost');
